/**
 * Reliably checks if the code is running on an iOS device (iPhone, iPad, iPod).
 * It uses a layered approach to handle modern APIs and fallbacks for older/current Safari.
 * @returns {boolean} True if the device is iOS, otherwise false.
 */
export function isIOS() {
  if (navigator.userAgentData && navigator.userAgentData.platform) {
    return navigator.userAgentData.platform === 'iOS';
  }

  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  }

  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

/**
 * Checks if the device is likely a generic tablet (e.g., iPad, Android Tablet, Windows Surface).
 * This works by checking for touch capabilities and trying to exclude mobile phones.
 * @returns {boolean} True if the device is likely a tablet.
 */
export function isTabletDevice() {
  if (isIOS()) {
    return true;
  }

  const hasTouch = navigator.maxTouchPoints > 0;
  const userAgent = navigator.userAgent.toLowerCase();

  const isMobilePhone = userAgent.includes('mobi');

  return hasTouch && !isMobilePhone;
}
